import { registerLexicalTextEntity } from "@lexical/text";
import { mergeRegister } from "../editor-utils";
import { $createAtMentionNode, AtMentionNode } from "./at-mention-node";
import { LexicalEditor } from "lexical/LexicalEditor";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";

export interface AtMentionConfig {
  getAtMentionMatch: (text: string) => null | { start: number; end: number };
}
const baseMentionRegex = /(?:\s|^)@(\w[\w.]{0,29})/;
const defaultAtMentionConfig: AtMentionConfig = {
  getAtMentionMatch: (text: string) => {
    const match = baseMentionRegex.exec(text);
    if (match) {
      const start = match.index + match[0].indexOf("@");
      const end = start + match[1].length + 1;
      return { start, end };
    }
    return null;
  },
};
export function registerLexicalAtMention(
  editor: LexicalEditor,
  config: typeof defaultAtMentionConfig = defaultAtMentionConfig
) {
  return mergeRegister(
    ...registerLexicalTextEntity(
      editor,
      config.getAtMentionMatch,
      AtMentionNode,
      (textNode) => $createAtMentionNode(textNode.getTextContent())
    )
  );
}

export function AtMentionPlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([AtMentionNode])) {
      throw new Error(
        "AtMentionPlugin: AtMentionNode not registered on editor"
      );
    }
    return registerLexicalAtMention(editor);
  }, [editor]);

  return null;
}
